<style lang="scss" src="./QInputS.scss"></style>
<script lang="ts" src="./QInputS.ts"></script>

<template>
  <q-skeleton type="QInput" class="skeleton-QInput"></q-skeleton>
</template>
